import type { OverviewMetric } from "../overviewTypes";

export function metricDisplay(metric: OverviewMetric | null): string {
  if (!metric) return "Not available";
  if (metric.status === "pending") return "Pending publication";
  if (metric.status === "suppressed") return metric.suppression === "minimum" ? "<5 contributors · figure withheld" : "Withheld to protect small groups";
  if (metric.value === null) return "Not available";
  const value = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 1 }).format(metric.value);
  if (metric.unit === "1–5") return `${value} / 5`;
  return metric.unit ? `${value}${metric.unit.startsWith("%") ? "" : " "}${metric.unit}` : value;
}

export default function MetricValue({ metric, className = "" }: { metric: OverviewMetric | null; className?: string }) {
  return <span className={className}>{metricDisplay(metric)}</span>;
}
